module.exports = "//__CDN_HOST__/2.0.8/img/calculator-banner-1.057eaab6.png";